import Base from 'records/Base';

import {
    FONTS_ASYNC_ACTION_START,
    FONTS_ASYNC_ACTION_SUCCESS,
    FONTS_ASYNC_ACTION_ERROR
} from 'actions/fonts';

const initialState = new Base({
    loading: false,
    errorMessage: null,
    data: [],
});

const actionsMap = {
    [FONTS_ASYNC_ACTION_START]: (state) => {
        return state.merge({
            loading: true,
            errorMessage: null,
        });
    },
    [FONTS_ASYNC_ACTION_SUCCESS]: (state, action) => {
        const fontList = action.data;
        return state.merge({
            loading: false,
            errorMessage: null,
            data: fontList,
        });
    },
    [FONTS_ASYNC_ACTION_ERROR]: (state, action) => {
        return state.merge({
            loading: false,
            errorMessage: action.error,
        });
    },
};

export default function fonts(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}